<template>
  <div class="vue-map-container-filtres">
    <ul>
      <li :class="{'is-active': types.includes('post_office')}">
        <a @click="togglePoi('post_office')" class="is-flex">
          <figure class="image is-24x24"><img src="static/icons/post_office.png"></figure>
          <span class="is-padding-xsmall">Poste</span>
        </a>
      </li>
      <li :class="{'is-active': types.includes('school')}">
        <a @click="togglePoi('school')" class="is-flex">
          <figure class="image is-24x24"><img src="static/icons/school.png"></figure>
          <span class="is-padding-xsmall">Écoles</span>
        </a>
      </li>
      <li :class="{'is-active': types.includes('university')}">
        <a @click="togglePoi('university')" class="is-flex">
          <figure class="image is-24x24"><img src="static/icons/university.png"></figure>
          <span class="is-padding-xsmall">Université</span>
        </a>
      </li>
      <li :class="{'is-active': types.includes('convenience_store')}">
        <a @click="togglePoi('convenience_store')" class="is-flex">
          <figure class="image is-24x24"><img src="static/icons/convenience_store.png"></figure>
          <span class="is-padding-xsmall">Alimentation</span>
        </a>
      </li>
      <li :class="{'is-active': types.includes('park')}">
        <a @click="togglePoi('park')" class="is-flex">
          <figure class="image is-24x24"><img src="static/icons/park.png"></figure>
          <span class="is-padding-xsmall">Parc</span>
        </a>
      </li>
      <!--<li :class="{'is-active': types.includes('city_hall')}">
        <a @click="togglePoi('city_hall')" class="is-flex">
          <figure class="image is-24x24"><img src="static/icons/city_hall.png"></figure>
          <span class="is-padding-xsmall">Mairie</span>
        </a>
      </li>-->
      <li :class="{'is-active': types.includes('restaurant')}">
        <a @click="togglePoi('restaurant')" class="is-flex">
          <figure class="image is-24x24"><img src="static/icons/restaurant.png"></figure>
          <span class="is-padding-xsmall">Restaurant</span>
        </a>
      </li>
      <li :class="{'is-active': types.includes('movie_theater')}">
        <a @click="togglePoi('movie_theater')" class="is-flex">
          <figure class="image is-24x24"><img src="static/icons/movie_theater.png"></figure>
          <span class="is-padding-xsmall">Cinéma et théâtre</span>
        </a>
      </li>
      <!--<li :class="{'is-active': types.includes('library')}">
        <a @click="togglePoi('library')" class="is-flex">
          <figure class="image is-24x24"><img src="static/icons/library.png"></figure>
          <span class="is-padding-xsmall">Bibliothèque</span>
        </a>
      </li>-->
      <li :class="{'is-active': types.includes('store')}">
        <a @click="togglePoi('store')" class="is-flex">
          <figure class="image is-24x24"><img src="static/icons/store.png"></figure>
          <span class="is-padding-xsmall">Magasin</span>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
  import { gmapApi } from 'vue2-google-maps'
  import { DefaultValues } from '@/mixins'
  export default {
    name: 'GmapFilter',
    mixins: [DefaultValues],
    data () {
      return {
        allTypes: ['post_office', 'school', 'university', 'convenience_store', 'park', 'restaurant', 'movie_theater', 'store'],
        types: [],
        results: [],
        newMap: null,
        currentMap: null,
        service: null,
        markers: [],
        loading: false
      }
    },
    props: {
      source: {
        type: Object,
        required: true
      },
      map: {
        type: HTMLDivElement,
        required: true
      }
    },
    watch: {
      google (v) {
        if (v && !this.currentMap) {
          this.setCurrentMap()
        }
      }
    },
    computed: {
      s () {
        return this.source
      },
      google () {
        if (gmapApi && gmapApi()) {
          return gmapApi().maps
        }
      },
      mainMarker () {
        return {
          icon: '',
          fullIcon: true,
          geometry: {location: new this.google.LatLng(this.s.location.latitude, this.s.location.longitude)}
        }
      },
      infoWindow () {
        return new this.google.InfoWindow()
      }
    },
    methods: {
      setCurrentMap () {
        let latLng = new this.google.LatLng(this.s.location.latitude, this.s.location.longitude)
        this.currentMap = new this.google.Map(this.map, {
          center: latLng,
          zoom: 13,
          options: {scrollwheel: false, streetViewControl: false},
          styles: this.mapStyle,
          zoomControlOptions: {position: this.google.ControlPosition.RIGHT_TOP}
        })
        this.setService(this.currentMap)
      },
      setService (currentMap) {
        this.$set(this, 'service', new this.google.places.PlacesService(currentMap))
        this.createMarker(this.mainMarker)
        // this.getNearbyPoi(this.types)
      },
      togglePoi (type) {
        if (this.markers.length === 1) {
          this.getNearbyPoi()
          this.currentMap.setZoom(15)
          setTimeout(() => {
            this.displayMarkers(type)
          }, 1000)
        } else this.displayMarkers(type)
      },
      displayMarkers (type) {
        this.markers.forEach(x => {
          if (x.type === type) {
            if (!x.getVisible()) x.setVisible(true)
            else x.setVisible(false)
          } else if (this.types.includes(x.type) || x.type === null) {
            x.setVisible(true)
          } else {
            x.setVisible(false)
          }
        })
        if (this.types.includes(type)) {
          let idx = this.types.findIndex(x => x === type)
          this.types.splice(idx, 1)
        } else {
          this.types.push(type)
        }
      },
      getNearbyPoi () {
        this.loading = true
        let location = new this.google.LatLng(this.s.location.latitude, this.s.location.longitude)
        this.deleteMarkers()
        this.createMarker(this.mainMarker)
        let _this = this
        _this.allTypes.forEach((type, i) => {
          let request = {
            location,
            radius: '1000',
            type
          }
          poiSearch(type, i, request)
        })
        _this.setMapOnAll(_this.currentMap)

        function poiSearch (type, i, request) {
          _this.service.nearbySearch(request, (res, status) => {
            if (status === _this.google.places.PlacesServiceStatus.OVER_QUERY_LIMIT) {
              setTimeout(function () {
                poiSearch(type, i, request)
              }, 1000)
            }
            if (status === _this.google.places.PlacesServiceStatus.OK) {
              res.forEach(result => _this.createMarker(result, type))
            }
          }, (err) => console.log(err))
        }
      },
      createMarker (marker, type = null) {
        let markerParams = {
          map: this.currentMap,
          position: marker.geometry.location,
          icon: type ? { url: `static/icons/${type}.png`, anchor: new this.google.Point(20, 20), scaledSize: new this.google.Size(30, 30) }
                    : { url: `static/icons/marker.png`, size: new this.google.Size(145, 145), scaledSize: new this.google.Size(50, 50), anchor: new this.google.Point(25, 25) }
        }
        if (marker.place_id) markerParams['placeId'] = marker.place_id
        let newMarker = new this.google.Marker(markerParams)
        if (type) {
          this.google.event.addListener(newMarker, 'click', () => {
            this.service.getDetails(newMarker, async (result, status) => {
              if (status !== this.google.places.PlacesServiceStatus.OK) {
                return
              }
              let photo = null
              if (result && 'photos' in result && result.photos.length) {
                photo = await result.photos[0].getUrl({maxWidth: 150})
              }
              this.infoWindow.setContent(`
                <div class="has-bg-white is-radius is-bordered">
                  <div class="columns is-gapless">
                    ${result && 'photos' in result && result.photos.length
                      ? `<div class="column is-one-third is-4" style="width: 170px; max-width: 33%">
                          <div class="gmap-image" style="background-image: url(${photo})"></div>
                        </div>`
                      : ''}
                    <div class="column is-8" style="width:100%">
                      <div class="columns is-gapless is-padding-left is-align-items-flex-start">
                        <div class="column is-padding-top-small">
                          <b>${result.name}</b>
                          <div class="is-padding-top-xsmall">${this.frenchType(type)}</div>
                          <div class="is-padding-top-xsmall">${result.rating ? `Note: ${result.rating}/5` : ''} ${'reviews' in result
                            ? `sur ${'reviews' in result ? result.reviews.length
                            : ''} avis` : ''}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              `)
              this.infoWindow.open(this.currentMap, newMarker)
            })
          })
        }
        if (type !== null) {
          newMarker.setVisible(false)
        }
        this.markers.push(Object.assign(newMarker, {type}))
      },
      setMapOnAll (map) {
        this.markers.forEach(marker => {
          marker.setMap(map)
        })
      },
      deleteMarkers () {
        this.setMapOnAll(null)
        this.markers = []
      },
      frenchType (type) {
        const TYPES = {
          'post_office': 'Poste',
          'school': 'Écoles',
          'university': 'Université',
          'convenience_store': 'Alimentation',
          'park': 'Parc',
          'restaurant': 'Restaurant',
          'movie_theater': 'Cinéma et théâtre',
          'store': 'Magasin'
        }
        return TYPES[type]
      }
    },
    mounted () {
      if (!this.$gmapApiPromiseLazy || typeof this.$gmapApiPromiseLazy !== 'function') return
      this.$gmapApiPromiseLazy().then(() => {
        this.setCurrentMap()
      })
    }
  }
</script>

<style scoped lang="sass">
  .vue-map-container-filtres
    bottom: 50px
    left: 9px
    top: 50px
    width: 176px

    li:not(.is-active) img
      filter: grayscale(100%) contrast(0.2) brightness(1.8)

</style>
<style lang="sass">
  .gmap-image
    width: 100px
    height: 100px
    background-position: center
    background-size: cover
</style>



// WEBPACK FOOTER //
// src/components/utils/GmapFilter.vue